<div class="container">
  <div class="message">
    <p>Access denied. Please reachout to the administrator for the accessing this resource.</p>
  </div>
</div>
